import { Firm } from '../../../../types/firm';
import FirmBranding from './FirmBranding';
import FirmDetails from './FirmDetails';
import FirmOptions from './FirmOptions';

type FirmDetailsContainerProps = {
    firm: Firm;
};

function FirmDetailsContainer({ firm }: FirmDetailsContainerProps): JSX.Element {
    return (
        <div className="grid gap-y-4">
            <FirmDetails firm={firm} />
            {/* <FirmBranding /> */}
            {/* <FirmOptions /> */}
        </div>
    );
}

export default FirmDetailsContainer;
